import { useRef } from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { compose, path } from 'ramda';

import { FileType } from './file-types';
import { useMigrationStatus } from 'shared/custom-hooks/useMigrationStatus';
import { useSelector } from 'react-redux';
import { selectSelectedCompany } from 'companies/companies.slice';
import { isPartiallyMigratedCdh, isPartiallyMigratedCobra } from 'shared/utils/migration-utils';

interface FileTypeSelectProps {
  value?: string;
  onSelectChange: (fileDescription?: string) => void;
  fileTypes: FileType[];
  disabled?: boolean;
}

function FileTypeSelect({ value, onSelectChange, fileTypes, disabled = false }: FileTypeSelectProps) {
  const labelRef = useRef<HTMLLabelElement>(null);

  const { current: handleChange } = useRef(compose(onSelectChange,path([ 'target', 'value' ])));
  const { hasMigrated, status } = useMigrationStatus();
  const selectedCompany = useSelector(selectSelectedCompany);
  const cobraFileTypeKeys = [ 4, 5, 14 ];
  const cdhFileTypeKeys = [ 1, 2, 3, 7, 8, 9, 10, 11, 12, 13 ];

  const filteredFileTypes = fileTypes.filter((fileTypeOption) => {
    if (cobraFileTypeKeys.includes(fileTypeOption.fileType)) {
      if (isPartiallyMigratedCobra(status, hasMigrated, selectedCompany)) {
        return false;
      }
    }

    if (cdhFileTypeKeys.includes(fileTypeOption.fileType)) {
      if (isPartiallyMigratedCdh(status, hasMigrated, selectedCompany)) {
        return false;
      }
    }

    return true;
  });

  return (
    <FormControl variant="outlined" className="w-full">
      <InputLabel ref={labelRef}>File Type</InputLabel>
      <Select className="file-type-select"
        label="File Type"
        value={value ?? ''}
        onChange={handleChange}
        native
        disabled={disabled}
      >
        <option value="" />
        {
          filteredFileTypes.map(file => (
            <option key={file.fileType} value={file.description}>{file.description}</option>
          ))
        }
      </Select>
    </FormControl>
  );
}

export default FileTypeSelect;
